module.exports = __webpack_public_path__ + "img/Cotton_harvest_1200x800.c4b4c649.png";